<template>
  <article class="news-teaser">
    <NuxtLink :to="post.path.alias" class="news-teaser__link">
      <div class="news-teaser__cover">
        <ResponsiveImage v-if="post.images[0]" :image="post.images[0]" />
      </div>
      <div class="news-teaser__content">
        <h2 class="news-teaser__heading">
          {{ post.title }}
        </h2>
        <div class="news-teaser__date">
          {{ useFormatDate('fullDateWeekday', post.date.value) }}
        </div>
        <div class="news-teaser__button">
          <IconLink label="mehr lesen" icon="CircleArrowRightFilled" />
        </div>
      </div>
    </NuxtLink>
  </article>
</template>
<script setup lang="ts">
defineProps<{
  post: any
}>()
</script>
<style lang="scss" scoped>
@use "~/assets/sass/tools";

.news-teaser {
  &__link {
    text-decoration: none;
  }

  &__cover {
    background-color: var(--color-grey);
    aspect-ratio: 3 / 2;

    :deep(.responsive-image) {
      height: 100%;

      img,
      picture {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__heading {
    margin: var(--space--s) 0;
  }

  &__button {
    margin-top: var(--grid-gutter);
  }
}
</style>
